module.exports = __webpack_public_path__ + "img/Jilin-speed.a94d71ba.png";